module.exports = __webpack_public_path__ + "img/4.812bb924.png";